export default __webpack_public_path__ + "static/media/header_bg_mx.47d1f180.png";